import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { videoInitialValues } from 'components/organisms/forms/video/VideoForm';
import { useHasPermission } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import { useDeleteVideo, useGetVideo } from 'services/video';
import { getMainTitle } from 'utils/global/mainTitle.utils';
import { getLastPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowToast } from 'utils/service/errorHandler';

const Video = () => {
  const videoId = useParamId('video');
  const { pathname } = useLocation();

  const navigate = useNavigate();
  const hasPermission = useHasPermission();

  const removeVideo = useDeleteVideo(videoId);
  const { data: video, isLoading } = useGetVideo(videoId);

  const onRemoveVideo = async (actions: PopupActions) => {
    await removeVideo?.mutateAsync(undefined, {
      onError: error => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => {
        navigate('/video');
      },
    });
  };

  return (
    <Form.Video
      i18nextPrefix='video'
      initialValues={
        video ? middleware.video.queryToForm(video) : videoInitialValues
      }
      onSubmit={() => {}}
      tittle={getMainTitle(video?.mainTitle)}
      status={{ isLoading: isLoading, displayMode: true }}
      topbarContent={
        <div className='flex w-full justify-end items-center'>
          {hasPermission('VideoPermissionsLIST**', 2) && (
            <Button
              isClear
              onlyIcon
              disabled={!video?.videoLink && !!video?.originalVideoLink}
              onClick={() => {
                video &&
                  navigate(
                    `/video/edit/${videoId}/${getLastPathname(pathname)}`,
                    {
                      replace: true,
                    }
                  );
              }}>
              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}
          {hasPermission('VideoPermissionsLIST**', 4) && (
            <MagellanPopups.DeleteWarning
              name={video?.mainTitle.title}
              onRemove={onRemoveVideo}
            />
          )}
        </div>
      }
    />
  );
};

export default Video;
